<div class="progress-bar-container">
  <div class="progress progress-moved" [style.width.%]="progress">
    <div class="progress-bar" [ngClass]="disableAnimation ? backgroundClass : 'animation ' + backgroundClass"></div>
  </div>
</div>
